import { createStyles } from '@lsy-netline-ui/netline-ui';

export default ({ spacing } : Theme) => createStyles({
  noConnection: {
    paddingLeft: spacing(1),
  },
});
